import { Controller } from "@hotwired/stimulus"
import Inputmask from "inputmask"

// Мягкая маска email — в отличие от телефона, у email нет фиксированной
// длины, поэтому classic-маска с подчёркиваниями мешала бы вводу. Alias
// "email" (встроен в саму библиотеку) не фиксирует длину частей, просто
// не даёт ввести второй "@" или пробел и структурирует ввод как
// локальная_часть@домен.зона по мере набора.
export default class extends Controller {
  connect() {
    this.mask = new Inputmask({ alias: "email" })
    this.mask.mask(this.element)
  }

  disconnect() {
    this.mask?.remove()
  }
}
